import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
  ArrowRight, MapPin, Zap, ShieldCheck,
  MessageCircle, X, Sun, Moon, Menu, Search,
  ArrowUpDown, Headset, RadioTower, Wrench,
  Building2, Globe, Cable, Network, LifeBuoy,
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter([]),
    provideAnimationsAsync(),
    provideHttpClient(),
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider({
        ArrowRight, MapPin, Zap, ShieldCheck,
        MessageCircle, X, Sun, Moon, Menu, Search,
        ArrowUpDown, Headset, RadioTower, Wrench,
        Building2, Globe, Cable, Network, LifeBuoy,
      }),
    },
  ],
};
